export const questionnaireEvaluationGetRequestReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { isSaveSuccess: false });
};
//# sourceMappingURL=questionnaireEvaluationGetRequestReducer.js.map